import * as yup from "yup"
import { DettaglioTavola } from "../../types"

export function initialValuesDettaglioTavola(dettaglioTavola?: DettaglioTavola | undefined) {
  if (dettaglioTavola) {
    return dettaglioTavola
  }
  return {
    titolo: "",
    descrizione: "",
    top: undefined,
    left: undefined,
    bottom: undefined,
    right: undefined,
  }
}

export function validationSchemaDettaglioTavola() {
  return yup.object().shape({
    titolo: yup.string().required("Campo obbligatorio"),
    // top: yup.number().required("Campo obbligatorio"),
    // left: yup.number().required("Campo obbligatorio"),
    // bottom: yup.number().required("Campo obbligatorio"),
    // right: yup.number().required("Campo obbligatorio"),
  })
}
